import React, { useState } from "react";
import InputField from "./InputField";
import Select from "./Select";
import { carsNameData } from "../Data/CarsData";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { addParts } from "../store/parts/actions/actionsCreators";
import { PartsAppSchema } from "../Schema/Schema";

const PartsApplicationForm = () => {
  const [stateNumber, setStateNumber] = useState(1);
  const dispatch = useDispatch();

  const initialValues = {
    enquiryRegarding: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    postCode: "",
    email: "",

    registrationNumber: "",
    vehicleMake: "",
    vehicleModel: "",
    externalColor: "",
    vehicleMileage: null,
    estimatedValue: null,

    numberOfOwners: null,
    firstRegistered: "",
    motExpires: "",
    generalCondition: "",
    lastService: "",
    serviceHistory: "",
    lastServiceMileage: null,
    externalDefects: "",
    internalDefects: "",
    otherComments: "",
    linkPhotos: "",
  };
  const {
    handleChange,
    handleSubmit,
    values,
    errors,
    touched,
    setErrors,
    setFieldTouched,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: PartsAppSchema[stateNumber - 1],
    onSubmit: async (values) => {
      try {
        await PartsAppSchema[totalSteps - 1].validate(values, {
          abortEarly: false,
        });

        dispatch(addParts(values, resetForm, setStateNumber));
      } catch (err) {
        console.log("Submission Error:", err);

        const formattedErrors = {};
        err.inner.forEach((error) => {
          formattedErrors[error.path] = error.message;
        });

        setErrors(formattedErrors);
        Object.keys(formattedErrors).forEach((field) =>
          setFieldTouched(field, true)
        );
      }
    },
  });
  const handleNext = async (event) => {
    event.preventDefault();

    const currentSchema = PartsAppSchema[stateNumber - 1];

    try {
      await currentSchema.validate(values, { abortEarly: false });

      if (stateNumber < totalSteps) {
        setStateNumber(stateNumber + 1);
      }
    } catch (err) {
      const formattedErrors = {};
      err.inner.forEach((error) => {
        formattedErrors[error.path] = error.message;
      });

      setErrors(formattedErrors);
      Object.keys(formattedErrors).forEach((field) =>
        setFieldTouched(field, true)
      );
    }
  };

  const handleBack = () => {
    if (stateNumber > 1) {
      setStateNumber(stateNumber - 1);
    }
  };
  const totalSteps = 3;

  return (
    <div className="container mx-0 mx-sm-0 mx-md-auto mx-lg-auto my-5">
      <div className="row">
        <div className="col-xxl-8 col-lg-7">
          <div className="card shadow-sm p-4 rounded-lg mx-auto">
            <div className="title-area mb-2">
              <span className="sub-title">Free Quote</span>
            </div>
            <div className="text-center mb-4">
              <h3 className="fw-bold">Online Vehicle Valuation</h3>
              <p className="text-muted">
                Step {stateNumber} of {totalSteps}
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                {stateNumber === 1 && (
                  <>
                    <div className="col-md-6">
                      <Select
                        options={carsNameData}
                        label="Enquiry regarding *"
                        name="enquiryRegarding"
                        onChange={handleChange}
                        values={values.enquiryRegarding}
                        error={errors.enquiryRegarding}
                        touched={touched.enquiryRegarding}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="text"
                        label="First Name *"
                        name="firstName"
                        onChange={handleChange}
                        values={values.firstName}
                        error={errors.firstName}
                        touched={touched.firstName}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="text"
                        label="Last Name *"
                        name="lastName"
                        onChange={handleChange}
                        values={values.lastName}
                        error={errors.lastName}
                        touched={touched.lastName}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="text"
                        label="Best Phone Number *"
                        name="phoneNumber"
                        onChange={handleChange}
                        values={values.phoneNumber}
                        error={errors.phoneNumber}
                        touched={touched.phoneNumber}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="text"
                        label="Postcode *"
                        name="postCode"
                        onChange={handleChange}
                        values={values.postCode}
                        error={errors.postCode}
                        touched={touched.postCode}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="email"
                        label="Email *"
                        name="email"
                        onChange={handleChange}
                        values={values.email}
                        error={errors.email}
                        touched={touched.email}
                      />
                    </div>
                  </>
                )}

                {stateNumber === 2 && (
                  <>
                    <div className="col-md-6">
                      <InputField
                        type="text"
                        label="Registration No *"
                        name="registrationNumber"
                        onChange={handleChange}
                        values={values.registrationNumber}
                        error={errors.registrationNumber}
                        touched={touched.registrationNumber}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="text"
                        label="Vehicle Make *"
                        name="vehicleMake"
                        onChange={handleChange}
                        values={values.vehicleMake}
                        error={errors.vehicleMake}
                        touched={touched.vehicleMake}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="text"
                        label="Vehicle Model *"
                        name="vehicleModel"
                        onChange={handleChange}
                        values={values.vehicleModel}
                        error={errors.vehicleModel}
                        touched={touched.vehicleModel}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="text"
                        label="External Color *"
                        name="externalColor"
                        onChange={handleChange}
                        values={values.externalColor}
                        error={errors.externalColor}
                        touched={touched.externalColor}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="number"
                        label="Vehicle Mileage *"
                        name="vehicleMileage"
                        onChange={handleChange}
                        values={values.vehicleMileage}
                        error={errors.vehicleMileage}
                        touched={touched.vehicleMileage}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="number"
                        label="Estimated Value £ *"
                        name="estimatedValue"
                        onChange={handleChange}
                        values={values.estimatedValue}
                        error={errors.estimatedValue}
                        touched={touched.estimatedValue}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="number"
                        label="Number of Owners *"
                        name="numberOfOwners"
                        onChange={handleChange}
                        values={values.numberOfOwners}
                        error={errors.numberOfOwners}
                        touched={touched.numberOfOwners}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="date"
                        label="First Registered - dd/mm/yyyy *"
                        name="firstRegistered"
                        onChange={handleChange}
                        values={values.firstRegistered}
                        error={errors.firstRegistered}
                        touched={touched.firstRegistered}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="date"
                        label="MOT Expires - dd/mm/yyyy *"
                        name="motExpires"
                        onChange={handleChange}
                        values={values.motExpires}
                        error={errors.motExpires}
                        touched={touched.motExpires}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="text"
                        label="General Condition *"
                        name="generalCondition"
                        onChange={handleChange}
                        values={values.generalCondition}
                        error={errors.generalCondition}
                        touched={touched.generalCondition}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="date"
                        label="Last Service - dd/mm/yyyy *"
                        name="lastService"
                        onChange={handleChange}
                        values={values.lastService}
                        error={errors.lastService}
                        touched={touched.lastService}
                      />
                    </div>
                    <div className="col-md-6">
                      <InputField
                        type="text"
                        label="Service History *"
                        name="serviceHistory"
                        onChange={handleChange}
                        values={values.serviceHistory}
                        error={errors.serviceHistory}
                        touched={touched.serviceHistory}
                      />
                    </div>
                    <div className="col-md-12">
                      <InputField
                        type="number"
                        label="Last Service Mileage *"
                        name="lastServiceMileage"
                        onChange={handleChange}
                        values={values.lastServiceMileage}
                        error={errors.lastServiceMileage}
                        touched={touched.lastServiceMileage}
                      />
                    </div>
                  </>
                )}

                {stateNumber === 3 && (
                  <>
                    <div className="col-md-12">
                      <InputField
                        type="text"
                        className="form-control"
                        name="linkPhotos"
                        label="Link to Photos"
                        onChange={handleChange}
                        value={values.linkPhotos}
                        error={errors.linkPhotos}
                      />
                    </div>
                    <div className="col-md-12">
                      <label>External Defects</label>
                      <textarea
                        className="form-control"
                        name="externalDefects"
                        onChange={handleChange}
                        value={values.externalDefects}
                      />
                      {errors.externalDefects && (
                        <div className="text-danger">
                          {errors.externalDefects}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label>Internal Defects</label>
                      <textarea
                        className="form-control"
                        name="internalDefects"
                        onChange={handleChange}
                        value={values.internalDefects}
                      />
                      {errors.internalDefects && (
                        <div className="text-danger">
                          {errors.internalDefects}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label>Other Comments</label>
                      <textarea
                        className="form-control"
                        name="otherComments"
                        onChange={handleChange}
                        value={values.otherComments}
                      />
                      {errors.otherComments && (
                        <div className="text-danger">
                          {errors.otherComments}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>

              <div className="d-flex justify-content-between mt-4">
                {stateNumber > 1 && (
                  <button
                    type="button"
                    className="btn style2 px-4 py-2"
                    onClick={handleBack}
                  >
                    Back
                  </button>
                )}

                {stateNumber < totalSteps ? (
                  <button
                    type="button"
                    className="btn style2 px-4 py-2"
                    onClick={handleNext}
                  >
                    Next
                  </button>
                ) : (
                  <button type="submit" className="btn style2 px-4 py-2">
                    Submit
                  </button>
                )}
              </div>
            </form>
            <div className=" text-muted mt-3">
              <p>
                If you are considering part exchanging your current vehicle, we
                provide a free, no-obligation quote. Contact our Sales
                Consultants on <strong> 07496360002</strong> or complete the
                valuation form below. We will get back to you with the best
                possible price for your car.
              </p>
            </div>
          </div>
        </div>
        <div className="col-xxl-4 col-lg-5">
          <aside className="sidebar-area ">
            <div className="widget widget_categories">
              <h3 className="widget_title">Contact Details</h3>
              <div className="d-flex align-items-center mb-3">
                <div>
                  <p className="mb-0 fw-semibold">Call Us:</p>
                  <p className="text-muted mb-0"> 07496360002</p>
                </div>
              </div>

              <div className="d-flex align-items-center mb-3">
                <div>
                  <p className="mb-0 fw-semibold">Email:</p>
                  <p className="text-muted mb-0">
                    inquiry@silverlineautoltd.co.uk
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div>
                  <p className="mb-0 fw-semibold">Address:</p>

                  <p className="text-muted mb-0">
                    UNIT 2 POOL ROAD INDUSTRIAL ESTATE NUNEATON, CV10 9AE,
                    United Kingdom
                  </p>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default PartsApplicationForm;
